import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import Tabs from '../../../ui/components/tabs'

import styles from './styles'

export const TRACKING_OPTIONS = {
  shippings: 'shipping',
  incidents: 'incidents',
  returns: 'returns',
  unscheduledPickups: 'unscheduledPickups',
}

const propTypes = {
  children: PropTypes.node,
  incidentsCount: PropTypes.number,
  unscheduledPickupsCount: PropTypes.number,
  selectedTracking: PropTypes.oneOf([
    TRACKING_OPTIONS.shippings,
    TRACKING_OPTIONS.incidents,
    TRACKING_OPTIONS.returns,
    TRACKING_OPTIONS.unscheduledPickups,
  ]).isRequired,
  changeSelectedTracking: PropTypes.func.isRequired,
  statusCodeSelectorSlot: PropTypes.node.isRequired,
}

const TrackingTypeSwitcherView = ({
  children,
  selectedTracking,
  changeSelectedTracking,
  incidentsCount = 0,
  statusCodeSelectorSlot,
  unscheduledPickupsCount = 0,
}) => {
  const t = useTranslations()

  const TABS = [
    {
      value: TRACKING_OPTIONS.shippings,
      label: t('noun:all-your-shippings'),
      content: children,
    },
    {
      value: TRACKING_OPTIONS.incidents,
      label: t('noun:incidents'),
      content: children,
      badgeValue: incidentsCount,
    },
    // {
    //   value: TRACKING_OPTIONS.returns,
    //   label: t('noun:returns'),
    //   content: children,
    // },
    {
      value: TRACKING_OPTIONS.unscheduledPickups,
      label: t('noun:unscheduled-pickups'),
      content: children,
      badgeValue: unscheduledPickupsCount,
    },
  ]
  return (
    <Grid container spacing={4} sx={styles.tabsContainer}>
      <Grid item xs={12}>
        <Tabs
          tabs={TABS}
          value={selectedTracking}
          onTabChange={changeSelectedTracking}
          extraContent={statusCodeSelectorSlot}
        />
      </Grid>
    </Grid>
  )
}

TrackingTypeSwitcherView.propTypes = propTypes

export default TrackingTypeSwitcherView
